/* Pureverr site chrome behaviour, all additive: the cart badge acknowledges a change of count, the navigation
   drawer's aria-expanded follows the drawer, the product media deck warms the slide the visitor is most likely to ask
   for next, the cart's sheen runs once, and (v2.5) one class on <html> tells the footer whether a product page's
   after_scroll sticky bar can come up at the end of the page. Nothing here is required for the page to work. */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
     1 - cart count. Shopify re-renders #cart-icon-bubble from the
     cart-icon-bubble section on every cart change, so the badge is a
     NEW element each time; watch the link's subtree rather than the
     badge, and only react when the number actually changed.
     --------------------------------------------------------------- */
  var link = document.getElementById('cart-icon-bubble');
  if (link && window.MutationObserver) {
    var read = function () {
      var b = link.querySelector('.cart-count-bubble span');
      return b ? b.textContent.trim() : null;
    };
    var last = read();
    new MutationObserver(function () {
      var now = read();
      if (now === null || now === last) return;
      last = now;
      var bubble = link.querySelector('.cart-count-bubble');
      if (!bubble) return;
      bubble.classList.remove('pv-cart-count--bump');
      /* one frame of nothing, so the class re-application actually restarts the transition */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          bubble.classList.add('pv-cart-count--bump');
          setTimeout(function () { bubble.classList.remove('pv-cart-count--bump'); }, 170);
        });
      });
    }).observe(link, { childList: true, subtree: true, characterData: true });
  }

  /* ---------------------------------------------------------------
     2 - the navigation drawer's aria-expanded
     The base theme sets aria-expanded when the summary is CLICKED, so
     closing with Escape leaves it reading "true" on a closed drawer -
     measured: details.open false, aria-expanded "true". The <details>
     element's own open state is the truth, so mirror that instead of
     trying to catch every way it can be closed.
     --------------------------------------------------------------- */
  var det = document.getElementById('Details-menu-drawer-container');
  if (det && window.MutationObserver) {
    var sum = det.querySelector('summary');
    var mirror = function () {
      if (sum) sum.setAttribute('aria-expanded', det.open ? 'true' : 'false');
    };
    mirror();
    new MutationObserver(mirror).observe(det, { attributes: true, attributeFilter: ['open'] });
  }

  /* ---------------------------------------------------------------
     3 - product media deck
     --------------------------------------------------------------- */
  var list = document.querySelector('media-gallery .product__media-list');
  if (!list) return;
  var slides = Array.prototype.slice.call(list.children);
  if (slides.length < 2) return;

  /* current slide semantics. The base theme marks the active dot with a class and nothing else;
     mirror it onto aria-current so the control says which image is showing, not just which dot is
     darker. The dots are re-marked by the theme's own slider code, so watch rather than compute. */
  var dots = document.querySelectorAll('media-gallery .slider-buttons .slider-counter__link');
  if (dots.length && window.MutationObserver) {
    var sync = function () {
      Array.prototype.forEach.call(dots, function (d) {
        if (d.classList.contains('slider-counter__link--active')) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    };
    sync();
    var mo = new MutationObserver(sync);
    Array.prototype.forEach.call(dots, function (d) {
      mo.observe(d, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* adjacent-slide preparation. NOT a preload of all eight: one neighbour at a time, at LOW fetch
     priority, only after the page has loaded and only when the browser is idle - so it can never
     compete with the first slide, which is the LCP candidate. Skipped entirely on Save-Data and on
     2g, where spending a megabyte on a swipe that may not happen is the wrong trade. */
  var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
  if (conn && (conn.saveData === true || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var warmed = [];
  function warm(i) {
    if (i < 0 || i >= slides.length || warmed[i]) return;
    warmed[i] = true;
    var img = slides[i].querySelector('img');
    if (!img || img.complete) return;
    if ('fetchPriority' in img) img.fetchPriority = 'low';
    else img.setAttribute('fetchpriority', 'low');
    img.loading = 'eager';
  }
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 240); };
  function after(fn) {
    if (document.readyState === 'complete') idle(fn, { timeout: 2000 });
    else window.addEventListener('load', function () { idle(fn, { timeout: 2000 }); }, { once: true });
  }
  warmed[0] = true;
  after(function () { warm(1); });

  /* and on every change of slide, prepare the next neighbour - again at idle, again one at a time */
  if (!window.IntersectionObserver) return;
  var current = 0;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.intersectionRatio < 0.6) return;
      var i = slides.indexOf(e.target);
      if (i < 0 || i === current) return;
      current = i;
      idle(function () { warm(i + 1); }, { timeout: 2000 });
    });
  }, { root: list, threshold: [0.6] });
  slides.forEach(function (s) { io.observe(s); });
})();

/* 2026-09-18 final UI pass, corrective: the cart's shipping-benefit sheen (assets/pureverr-cart.css `pv-cart-ship-sheen`) runs once
   per page view. The drawer's markup is replaced on every cart change, so CSS alone would replay it; the first `animationend`
   sets a flag on <html> and the stylesheet switches the animation off from then on. No cart code is involved. */
(function () {
  if (window.__pvSheenOnce) return;
  window.__pvSheenOnce = true;
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'pv-cart-ship-sheen') document.documentElement.setAttribute('data-pv-sheen-done', '');
  });
})();

/* v2.5 F2 (2026-10-03): can this page's after_scroll sticky bar come up at the end of the page?
   assets/pureverr-shell.css section 6 keeps a footer-coloured room under the footer for main-product's sticky bar, so the
   page is as long as it was with the theme's own margin and the bar comes up where it always did. The theme shows an
   after_scroll bar once `scrollY > mainAddToCart.offsetTop + mainAddToCart.offsetHeight` (assets/global.js, StickyAtc;
   the same expression is used here, on purpose). If even the page's furthest scroll, room included, stays at or below
   that line, the bar can never come up, and the room would only be an empty band: <html> then gets
   .pv-sticky-unreached and the stylesheet drops the room. Decided from geometry alone (the page's length, the viewport,
   the button), never from where the reader is, and re-decided when the window or the page's height changes. The elements
   are looked up again on every decision, so a section re-rendered in the theme editor is followed. A page without the
   main Add to cart cannot reveal the bar (the theme's own check needs it), so it gets no room. "always" bars (the
   FaucetPro card) are not touched. Without this script the room simply stays. */
(function () {
  'use strict';
  if (window.__pvStickyReach) return;
  window.__pvStickyReach = true;
  var root = document.documentElement, ticking = false;
  var px = function (el, name) { return parseFloat(getComputedStyle(el).getPropertyValue(name)) || 0; };
  function afterScrollBar() {
    var list = document.querySelectorAll('sticky-atc.pv-stickybar[data-after-scroll="true"]');
    for (var i = 0; i < list.length; i++) if (!list[i].closest('quick-add-modal')) return list[i];
    return null;
  }
  function decide() {
    ticking = false;
    var bar = afterScrollBar(), footer = document.querySelector('footer.footer');
    if (!bar || !footer) { root.classList.remove('pv-sticky-unreached'); return; }
    var atc = document.getElementById('ProductSubmitButton-' + bar.getAttribute('data-section'));
    var reach = false;
    if (atc) {
      /* the room section 6 gives this bar: its height + how far it floats above the viewport's bottom edge (its
         computed `bottom`) + the clearance step. From the bar itself, not from the stylesheet's current value, which is
         only 1px until pureverr-sticky.js has published the height (a first version read it there, too early, and
         wrongly dropped the room: caught by a fresh-load test per width) */
      var room = bar.offsetHeight + (parseFloat(getComputedStyle(bar).bottom) || 0) + px(footer, '--pv-sticky-clear');
      var now = parseFloat(getComputedStyle(footer, '::after').height) || 0;   /* the room in the page right now, if any */
      var furthest = root.scrollHeight - window.innerHeight - now + room;
      reach = furthest > atc.offsetTop + atc.offsetHeight;
    }
    if (reach === root.classList.contains('pv-sticky-unreached')) root.classList.toggle('pv-sticky-unreached', !reach);
  }
  function schedule() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(decide);
  }
  if (!afterScrollBar()) return;
  schedule();
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
  ['shopify:section:load', 'shopify:section:unload'].forEach(function (t) { document.addEventListener(t, schedule); });
  if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(document.body);
})();
